import { useMutation } from '@apollo/client/react';
import { useCallback, useEffect, useState } from 'react';

import { UpdateKarteAppointmentDescriptionDocument } from '~/graphql/generated/graphql';

export const useUpdateMemo = (appointmentId?: string) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [latestMemo, setLatestMemo] = useState({ memo: '', mutationCalled: false });
  const [updateMemo, { data }] = useMutation(UpdateKarteAppointmentDescriptionDocument);

  useEffect(() => {
    if (!data) return;

    const latestDescription = data?.updateAppointmentDescription?.appointment?.description || '';
    setLatestMemo({ memo: latestDescription, mutationCalled: true });
  }, [data]);
  const update = useCallback(
    async (memo: string) => {
      if (appointmentId) {
        setIsUpdating(true);
        try {
          await updateMemo({
            variables: {
              input: {
                appointmentId,
                description: memo,
              },
            },
          });
        } catch (_error) {
          throw new Error(_error.message, { cause: _error });
        }
        setIsUpdating(false);
      }
    },
    [appointmentId, updateMemo],
  );

  return {
    isUpdating,
    latestMemo,
    update,
  };
};
